/**
 * ページネーションリクエストVO
 *
 * @export PagenationRequestModel
 * @class PagenationRequestModel
 */
export class PagenationRequestModel {
  // 媒体区分
  public MediumType = String('');
  // 使用開始 受注コード
  public OrderCode = String('');
  // 生協コード
  public CoopCode = String('');
  // データグリッド上の選択位置
  public SelectedIndex = Number(0);
}
